<template>
  <div class="search-slide-item">
    <div class="slide-info">
      <div class="relative flex-none pl-4">
        <div
          class="slide-image"
          :style="{ 'background-image': 'url(' + slide.image + ')' }"
          v-if="slide.image"
        ></div>
        <div
          class="slide-image"
          :style="{ 'background-image': 'url(' + slide.backgroundImage + ')' }"
          v-if="!slide.image && slide.backgroundImage"
        >
        </div>
        <div
          class="slide-image"
          :style="{ 'background-image': 'url(' + require('@/assets/images/icon/default-thumbnail.svg') + ')' }"
          v-if="!slide.image && !slide.backgroundImage"
        ></div>
        <span
          class="slide-time-to-answer"
          v-if="slide.timeToAnswer && showTimeToAnswer"
        >
          <aha-icon
            name="pending"
            viewBox="0 0 18 19"
            width="14"
            height="14"
            class="-mt-0.75"
          />
          {{ slide.timeToAnswer }}s
        </span>
      </div>
      <div class="flex flex-col flex-grow ml-4 justify-evenly">
        <div class="text-xs slide-type text-base-90">
          {{ getSlideTypeName(slide) }}
        </div>
        <div class="slide-title" :title="slide.title">
          {{ slide.title }}
        </div>
      </div>
    </div>
    <div v-if="slide.titleDesc" class="slide-desc">
      {{ slide.titleDesc }}
    </div>
    <div v-if="!slide.titleDesc && !isShowSlideOptions" class="slide-desc default-desc">
      {{ getSlideTypeDesc(slide.type) }}
    </div>
    <div class="slide-options" v-if="isShowSlideOptions">
      <div v-if="slide.type === 'pickAnswer' && slide.slideType === 'typeAnswer'">
        <div class="slide-option">
          <p class="flex-grow truncate" :title="slide.correctQuizTypeAnswer">
            {{ slide.correctQuizTypeAnswer }}
          </p>
        </div>
        <div
          class="slide-option"
          v-for="(option, index) in slide.otherCorrectQuiz"
          :key="index"
        >
          <p class="flex-grow truncate" :title="option.title">
            {{ option.title }}
          </p>
        </div>
      </div>
      <div v-else>
        <div
          class="slide-option"
          v-for="(option, index) in slide.SlideOptions"
          :key="option.id"
        >
          <p class="flex-grow truncate" :title="option.title">
            <span class="font-bold">{{ index + 1 }}. </span>
            {{ option.title }}
          </p>
          <img
            class="slide-option-image"
            v-if="option.imageCropped"
            :src="option.imageCropped"
            alt=""
          >
          <span
            v-if="option.correct && !isNotShowCorrectSlideOptions"
            class="absolute right-3 top-4"
            v-tooltip="$i18nPresenter.t('This is the correct answer')"
          >
            <aha-icon
              name="circle-check"
              viewBox="0 0 24 24"
              width="18"
              height="18"
              class="mb-0.5 text-green-50"
            />
          </span>
          <span
            v-if="!option.correct && !isNotShowCorrectSlideOptions && hasCorrectAnswer(slide)"
            class="absolute right-3 top-4"
            v-tooltip="$i18nPresenter.t('This is the incorrect answer')"
          >
            <aha-icon
              name="incorrect"
              viewBox="0 0 18 18"
              width="16"
              height="16"
              class="mb-0.5 text-red-50"
            />
          </span>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="flex-grow text-xs text-base-90">
        <div class="flex w-full template-info" v-if="!isFromOpenTriviaDB">
          <img
            v-if="isOfficial"
            class="mr-2"
            :src="require('@/assets/images/icon/aha-official-avt.svg')"
          >
          <aha-avatar
            v-else
            class="mt-1 mr-2"
            :name="getAuthorName"
            :image="getAuthorAvt"
            :width="28"
            :height="28"
          />
          <div class="flex-wrap inline-flex pr-10 w-full">
            <b class="template-name w-full" :title="slide.presentationName">
              {{ slide.presentationName }}
            </b>
            <span class="template-author w-full">
              <img
                v-if="isOfficial"
                class="inline mr-0.5 icon-official"
                :src="require('@/assets/images/icon/author-checked.svg')"
              >
              <span class="mt-0.5 truncate">
                {{ isOfficial ? 'AhaSlides Official' : getAuthorName }}
              </span>
            </span>
          </div>
        </div>
        <span
          class="relative group"
          @click="handleClickCredit"
          v-else
        >
          {{ $i18nPresenter.t('Credit:') }}
          <aha-link size="xs">
            opentdb.com
          </aha-link>
          <aha-icon
            class="open-new-window"
            name="open-new-window"
          />
        </span>
      </div>
      <div class="flex-none">
        <aha-button
          @click="addSlide(slide)"
          :submitting="submitting"
          :disabled="submitting || submited || isLocking"
        >
          <span v-if="!submited">{{ $i18nPresenter.t('Add') }}</span>
          <span v-else>{{ $i18nPresenter.t('Added') }}</span>
        </aha-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapActions } from 'vuex'
import Constant from '@/constant'
import SlideApi from '@/api/slide'
import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import mixpanelUtils from '@/utils/mixpanel.utils'

const SHOW_OPTIONS_TYPES = [
  'multipleChoice',
  'imageChoice',
  'scale',
  'pickAnswer',
  'spinnerWheel',
  'bulletPoints',
]
const NOT_SHOW_CORRECT_TYPES = [
  'scale',
  'spinnerWheel',
]
const SHOW_TIME_ANSWER = [
  'pickAnswer',
]

export default {
  components: {
  },
  props: {
    slide: {
      type: Object,
      required: false,
      // required: true,
      default: () => {
        return {
          id: 1,
          type: 'Pick Answer',
          title: 'Who was Gryffindor’s Quidditch-obsessed keeper between 1987 and 1994?',
          image: '/17b67a5cd52f2a5f3d792c4ee8abe949.svg',
          titleDesc: 'Word Cloud Description',
          presentation: {
            title: 'presentation 1',
          },
          SlideOptions: [
            {
              id: 1,
              title: 'A. this is a option 1',
              isCorrect: true,
            },
            {
              id: 2,
              title: 'B. this is a option 2',
              isCorrect: false,
            },
          ],
        }
      },
    },

    textSearch: {
      type: String,
      default: '',
    },
    seletedType: {
      type: Object,
      default: () => {
        return {}
      },
    },
    page: {
      type: Number,
      default: 1,
    },
    isSubmittingMultiple: {
      type: Boolean,
      default: false,
    },
    isLocking: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitting: false,
      submited: false,
    }
  },
  computed: {
    getAuthorAvt() {
      if (this.slide.user) {
        return this.slide.user.avatar
      }
      return ''
    },
    getAuthorName() {
      if (this.slide.user) {
        return `${this.slide.user.firstName} ${this.slide.user.lastName}`
      }
      return ''
    },
    isOfficial() {
      return this.slide.user && this.slide.user.type === 'official'
    },
    isShowSlideOptions() {
      return SHOW_OPTIONS_TYPES.indexOf(this.slide.type) > -1
    },
    isNotShowCorrectSlideOptions() {
      return NOT_SHOW_CORRECT_TYPES.indexOf(this.slide.type) > -1
    },
    showTimeToAnswer() {
      return SHOW_TIME_ANSWER.indexOf(this.slide.type) > -1
    },
    isFromOpenTriviaDB() {
      return this.slide.presentationName && this.slide.presentationName.includes('OpenTDB')
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleClickCredit() {
      window.open('https://opentdb.com', '_blank')
    },
    getListSlideTypes() {
      let slideTypesList = []
      Constant.allTypeSections.forEach((item) => {
        slideTypesList = slideTypesList.concat(item.slideTypes)
      })
      return slideTypesList
    },
    getSlideType(type) {
      const slideTypeList = this.getListSlideTypes()
      return slideTypeList.filter((t) => t.type === type)
    },
    getSlideTypeName(slide) {
      const slideTypes = this.getSlideType(slide.type)
      if (!slide.slideType) {
        return slideTypes.find((t) => t.type === slide.type).name
      }
      return slideTypes.find((t) => t.type === slide.type && t.slideType === slide.slideType).name
    },
    async addSlide(item) {
      if (this.submitting) return
      if (this.isSubmittingMultiple) {
        EventBus.$emit('slide-search-popup:add-new-slide')
      }
      this.submitting = true
      this.$emit('lockAddSlide')
      const payload = {
        duplicatedSlideId: item.id,
        destinatedPresentationId: this.$store.state.presentation.id,
        isIncludingResponseData: false,
        areDuplicatedSlidesPublic: true,
      }
      const index = this.$store.state.presentation.slides.findIndex((slide) => {
        if (slide.id) {
          return slide.id === this.$store.state.slideActive.id
        }
        return slide.timestamp === this.$store.state.slideActive.timestamp
      })
      if (index !== -1 && index) {
        payload.insertAfter = this.$store.state.presentation.slides[index - 1].order
      }

      try {
        const resp = await SlideApi.duplicateOtherPresentation(payload)
        this._handleDataAfterAddSlide(resp, index, item)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    _handleDataAfterAddSlide(resp, index, item) {
      const defaultSlideId = this.$store.state.presentation.slides[index].id
      if (resp.body.slides[0] && resp.body.slides[0].additionalFields) {
        resp.body.slides[0].additionalFields =
          JSON.parse(resp.body.slides[0].additionalFields)
      }
      this.$store.state.presentation.slides[index] = resp.body.slides[0]
      this.updateSlideActiveAction(resp.body.slides[0])
      this.submitting = false
      this.submited = true
      setTimeout(() => {
        EventBus.$emit('makeSlideActive', this.$store.state.presentation.slides[index])
        EventBus.$emit('handleHoverOnSlideType', {}, 'out', 'right-side') // AHA-9801, hide preview after adding a slide when user accidentally hovers on right side
      }, 250)
      if (this.$store.state.isNewPresentation) {
        this.$store.state.isNewPresentation = false
        if (defaultSlideId) {
          SlideApi.updateSlideById(defaultSlideId, {
            deleted: true,
          })
        }
      }

      if (item.type === 'pickAnswer') {
        EventBus.$emit('addSlideLeaderboard')
      } else {
        this.$emit('unlockAddSlide')
      }

      const dataTrack = {
        q: this.textSearch,
        page: this.page,
      }
      const types = []
      if (this.seletedType && this.seletedType.filter && this.seletedType.filter.length) {
        this.seletedType.filter.forEach((item) => {
          types.push(item.type)
        })
      }
      if (types.length) {
        dataTrack.types = types.toString()
      }
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Create new slide',
        'Use slide template',
        item.id,
        {
          slideType: item.type,
          ...mixpanelUtils.getPresentationContext(this.$store.state.presentation),
          slideId: resp.body.slides[0].id,
        },
      )
      this.$emit('addedSlide')
    },
    getSlideTypeDesc(type) {
      const slideType = this.getSlideType(type)
      return slideType && slideType.desc
    },
    hasCorrectAnswer(item) {
      return item.SlideOptions.some((slideOption) => slideOption.correct)
    },
  },
}
</script>

<style lang="scss" scoped>
.search-slide-item {
  @apply shadow rounded-lg;
  @apply w-full;
  background-color: #fff;
  padding: 16px 0;

  .slide-image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 120px;
    height: 68px;
    border-radius: 4px;
  }
}
.slide-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  max-height: 48px;
  padding-right: 8px;
  @apply font-bold text-base-90 text-base;
  line-height: 1.3rem;
}

.open-new-window {
  @apply text-base-50 hidden group-hover:inline-block absolute;
  top: -4px;
}

.slide-info {
  @apply flex items-stretch;
  border-bottom: 1px solid #EBEBEB;
  padding-bottom: 16px;
}
.slide-option-image {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 36px;
  top: 6px;
  border-radius: 4px;
}
.slide-time-to-answer {
  bottom: 5px;
  right: 5px;
  color: #fff;
  background: #3a3530;
  padding: 3px;
  position: absolute;
  border-radius: 4px;
}
.slide-desc {
  @apply p-4;
  border-bottom: 1px solid #EBEBEB;
}

.slide-option {
  @apply flex flex-row p-4 relative;
  border-bottom: 1px solid #EBEBEB;
  padding-right: 86px;
}

.actions {
  @apply flex flex-row px-4 pt-4 items-center;
}

.template-info{
  font-size: 12px;
  .template-name{
    color: #313131;
  }
  .template-author{
    color: #707070;
  }
  .icon-official{
    width: 12px;
    height: 12px;
  }
}

</style>
